export const logActionsMiddleware = () => (next: (arg0: {type: string}) => any) => (action: {type: any}) => {
    if (!action) {
        return next({type: 'UNKNOWN_REQUEST'})
    }
    // console.log(action.type)
    return next(action)
}
